"use client"

import type React from "react"
import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { data } from "../../data"

interface IServicesDropdownComponentProps {
    isActive?: boolean
    onClick?: () => void
}

export const ServicesDropdownComponent: React.FC<IServicesDropdownComponentProps> = ({ isActive = false, onClick }) => {
    const { services } = data
    const [isOpen, setIsOpen] = useState(false)
    const [activeSubmenu, setActiveSubmenu] = useState<number | null>(null)
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1024)
        handleResize() // initial check
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    const handleItemClick = () => {
        onClick?.()
        setIsOpen(false)
        setActiveSubmenu(null)
    }

    const toggleMobileSubmenu = (index: number) => {
        setActiveSubmenu((prev) => (prev === index ? null : index))
    }

    return (
        <li
            className="dropdown"
            onMouseEnter={() => !isMobile && setIsOpen(true)}
            onMouseLeave={() => !isMobile && setIsOpen(false)}
        >
            <a
                href={data.routes.services}
                className={isActive ? "active" : ""}
                onClick={(e) => {
                    if (isMobile) {
                        e.preventDefault()
                        setIsOpen(!isOpen)
                    } else {
                        onClick?.()
                    }
                }}
            >
                <span className={`${isMobile ? "" : "gradient-text"} ${isActive ? "": "text-secondary"}`}>Services</span>
                <i className={`bi ${isMobile ? "" : "gradient-text"} px-1 bi-chevron-${isOpen ? "up" : "down"}  toggle-dropdown transition-transform duration-300`} />
            </a>

            {isOpen && (
                <ul
                    className={`transition-all duration-300 ease-in-out pl-3 space-y-0 ${isMobile ? "animate-slide-down mobile-submenu-container" : ""
                        }`}
                >
                    {services.map((iservice, index) => (
                        <li className="dropdown" key={iservice.id}>
                            <Link
                                to={iservice.route}
                                className={` ${isMobile ? "mobile-submenu-item" : ""}`}
                                onClick={(e) => {
                                    if (isMobile) {
                                        e.preventDefault()
                                        toggleMobileSubmenu(index)
                                    } else {
                                        handleItemClick()
                                    }
                                }}
                            >
                                <span className="me-3">{iservice.title}</span>
                                <i
                                    className={`bi bi-chevron-${activeSubmenu === index && isMobile ? "up" : "right"} toggle-dropdown transition-transform duration-300 ${isMobile ? "text-gray-700" : ""}`}
                                />
                            </Link>

                            {(isMobile ? activeSubmenu === index : true) && (
                                <ul
                                    className={`pl-4 mt-1 overflow-auto transition-all duration-300 ease-in-out ${isMobile ? "animate-slide-down mobile-submenu-nested" : ""
                                        }`}
                                >
                                    {iservice.services.map((service) => (
                                        <li key={service.id} className="transition-all duration-200 ease-in-out">
                                            <Link
                                                to={service.route}
                                                onClick={handleItemClick}
                                                className={isMobile ? "mobile-submenu-nested-item" : ""}
                                            >
                                                {service.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </li>
    )
}
